import React from 'react';

import {useMediaGridSettingsDisplay} from '../../hooks';
import {AxisDropdown} from '../common/AxisDropdown';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';
import {updateAxisConfig} from './util';

export const YAxis = () => {
  const {updateConfig, settingsLevel, panelRef} = useMediaSettingsContext();
  const gridSettings = useMediaGridSettingsDisplay(settingsLevel, panelRef);
  return (
    <AxisDropdown
      configField="gridSettings"
      initialValue={gridSettings.yAxis}
      onSelectOption={option =>
        updateAxisConfig(option, gridSettings, updateConfig, 'yAxis')
      }
      title="Y-Axis"
    />
  );
};
